
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg-inline--fa fa-clone fa-w-16 fa-2x",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","data-icon":"clone","data-prefix":"fad","viewBox":"0 0 512 512","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"fa-group"},[_c('path',{staticClass:"fa-secondary",attrs:{"d":"M48 512a48 48 0 01-48-48V176a48 48 0 0148-48h48v208a80.09 80.09 0 0080 80h208v48a48 48 0 01-48 48H48z"}}),_c('path',{staticClass:"fa-primary",attrs:{"d":"M512 48v288a48 48 0 01-48 48H176a48 48 0 01-48-48V48a48 48 0 0148-48h288a48 48 0 0148 48z"}})])])
          )
        }
      }
    